import { computed } from 'vue';
import { CallTargetSfSyncSettingInfo } from '@/api/openapi';

const useCallResultActionState = (getSfSyncSettingInfo: () => CallTargetSfSyncSettingInfo | null | undefined) => {
  const canCreateCallResult = computed(() => {
    const sfSyncSettingInfo = getSfSyncSettingInfo();
    return !sfSyncSettingInfo?.callResultSfSync || sfSyncSettingInfo?.sfUserId != null;
  });

  return {
    canCreateCallResult,
  };
};

export default useCallResultActionState;
